import React from 'react';
import { Link } from 'react-router-dom';
import PaperImage from '../images/WhyAgtechFails.png';
import AnkitPhoto from '../images/Ankit.png';
import LalPhoto from '../images/Lal.png';

const WhyAgTechFails = () => {
  return (
    <div className="pub-page">

      <div className="pub-breadcrumb">
        <div className="container">
          <Link to="/resources" className="pub-breadcrumb-link">← Back to Resources</Link>
        </div>
      </div>

      <div className="pub-header">
        <div className="container">
          <span className="pub-badge">🔬 PEER-REVIEWED · OPEN ACCESS</span>
          <h1 className="pub-title">
            Why AgTech Startups Fail? Evidence from Global Shutdown Patterns in 2025
            and the Cost-adoption Mismatch Effect
          </h1>
          <p className="pub-date">January 2026</p>
        </div>
      </div>

      <div className="pub-body">
        <div className="container pub-layout">

          <div className="pub-main">

            <div className="pub-map-wrapper">
              <img
                src={PaperImage}
                alt="Why AgTech Startups Fail paper"
                className="pub-map-img"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="pub-map-fallback" style={{ display: 'none' }}>
                <span>📄</span>
                <p>Paper image not found — make sure WhyAgtechFails.png is in src/images/</p>
              </div>
            </div>

            <div className="pub-download-row">
              <a
                href="https://digitalcommons.unl.edu/biosysengpres/83/"
                className="pub-download-link"
                target="_blank"
                rel="noopener noreferrer"
                download
              >
                download PDF
              </a>
            </div>

            <div className="pub-section">
              <h2 className="pub-section-title">Abstract</h2>
              <p style={{ color: '#475569', lineHeight: '1.7' }}>
                Agricultural technologies are widely seen as a driver for sustainability,
                resilience, and food-system transformation. Yet in 2025, agtech startups
                across North America, Europe, Asia, and Africa experienced multiple shutdowns.
                Although each company closed for its own reasons, the failures highlight
                consistent underlying patterns. We analyze 18 publicly reported shutdowns
                across controlled-environment agriculture (CEA), robotics, insect protein,
                digital platforms, sensors, and ag-biotechnology. We find that most ventures
                struggled not with scientific feasibility but with economic and adoption
                dynamics at the farm level. We identify a Cost-Adoption Mismatch Effect,
                in which the capital and operational burden of a technology exceeds farmers'
                capacity to adopt it, even when technical performance is validated. We
                conclude by outlining emerging opportunities where economic, operational,
                and adoption realities are better aligned, and by identifying implications
                for founders, investors, policymakers, and ecosystem builders navigating
                the future of agricultural innovation.
              </p>
            </div>
          </div>

          <aside className="pub-sidebar">

            <div>
              <h3 className="pub-sidebar-title">Authors</h3>

              <div className="pub-author-card">
                <div className="pub-author-photo-wrap">
                  <img
                    src={AnkitPhoto}
                    alt="Ankit Chandra"
                    className="pub-author-photo"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="pub-author-photo-fallback" style={{ display: 'none' }}>
                    AC
                  </div>
                </div>
                <div className="pub-author-info">
                  <p className="pub-author-name">Ankit Chandra</p>
                  <p className="pub-author-role">Founder, Spur Ventures</p>
                  <p className="pub-author-org">University of Nebraska–Lincoln</p>
                </div>
              </div>

              <div className="pub-author-card">
                <div className="pub-author-photo-wrap">
                  <img
                    src={LalPhoto}
                    alt="I. Lal"
                    className="pub-author-photo"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      e.target.nextSibling.style.display = 'flex';
                    }}
                  />
                  <div className="pub-author-photo-fallback" style={{ display: 'none' }}>
                    IL
                  </div>
                </div>
                <div className="pub-author-info">
                  <p className="pub-author-name">I. Lal</p>
                  <p className="pub-author-role">Economist</p>
                  <p className="pub-author-org">Department of Agricultural Economics, UNL</p>
                </div>
              </div>
            </div>

            <div>
              <h3 className="pub-sidebar-title">Publication Info</h3>
              <div className="pub-info-block">
                <p className="pub-info-label">Published</p>
                <p className="pub-info-value">January 2026</p>
              </div>
              <div className="pub-info-block">
                <p className="pub-info-label">Access</p>
                <p className="pub-info-value">Open Access (CC BY-NC 4.0)</p>
              </div>
              <div className="pub-info-block">
                <p className="pub-info-label">Institution</p>
                <p className="pub-info-value">Dept. of Biological Systems Engineering, UNL</p>
              </div>
            </div>

            <div>
              <h3 className="pub-sidebar-title">Share</h3>
              <div className="pub-share-links">
                <a
                  href="https://www.linkedin.com/company/the-spur-ventures"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="pub-share-btn"
                >
                  LinkedIn
                </a>
              </div>
            </div>

          </aside>
        </div>
      </div>
    </div>
  );
};

export default WhyAgTechFails;